import type { Tag } from 'models';
import { usePermissions } from 'permissions';
import { Card, Col, CompassLineIcon, DetailsCategoryItem, Row } from 'ui';
import { ChannelsDetailTags } from './channels-detail-tags';
import { useGetChannelAppearanceInformation } from './hooks';

type P = {
  channelAppearance: { featured?: boolean; visible?: boolean };
  channelTags?: Tag[];
  organizationId?: string;
};

const ChannelsDetailCard = ({ channelAppearance, channelTags, organizationId }: P) => {
  const channelAppearanceInformation = useGetChannelAppearanceInformation({
    channelAppearance,
  });
  const { canViewChannelsSection } = usePermissions();

  if (!canViewChannelsSection({ organizationId }) || !channelAppearanceInformation) {
    return null;
  }

  return (
    <Card title={<Card.Title icon={<CompassLineIcon />}>Channels</Card.Title>}>
      <Row gutter={[0, 'ms']}>
        <Col>
          <DetailsCategoryItem
            category="appearance"
            description={channelAppearanceInformation.description}
            icon={channelAppearanceInformation.icon}
            name={channelAppearanceInformation.name}
          />
        </Col>
        {channelTags && channelTags.length > 0 ? (
          <Col>
            <ChannelsDetailTags tags={channelTags} />
          </Col>
        ) : null}
      </Row>
    </Card>
  );
};

export default ChannelsDetailCard;
